<usb-base-item
  [item]="item"
  [styleSidebar]="styleSidebar"
  [currencyAgency]="currencyAgency"
  [currencies]="currencies"
  [clientsSettingAppBooking]="clientsSettingAppBooking"
>
  <div class="row pt-3">
    <!-- Left Column -->
    <div class="col-6">
      <!-- Adults -->
      <div class="d-flex align-items-center mb-4" style="gap: 2px;">
        <img width="20" height="20" src="../../../../../../assets/icons/itinerary/persona.svg"/>
        <span style="font-family: 'Rubik'; font-size: 13px; font-weight: 400; text-transform: none;">{{ item.adults }} {{ item.adults === 1 ? 'Adulto' : 'Adultos' }}</span>
      </div>

      <!-- Date -->
      <div class="d-flex flex-column mb-4">
        <span
          style="
            font-family: 'Rubik';
            font-size: 13px;
            font-weight: 400;
            line-height: 1;
            color: #3e3e3e;
            text-transform: none;
          "
        >
          Fecha:
        </span>
        <span
          style="
            font-family: 'Rubik';
            font-size: 13px;
            font-weight: 500;
            line-height: 1;
            color: #000000;
            text-transform: none;
          "
        >
          {{ item.selectDay | date: "EEE. dd MMM yyyy" }}
        </span>
      </div>

      <!-- Duration -->
      <div class="d-flex flex-column mb-4">
        <span
          style="
            font-family: 'Rubik';
            font-size: 13px;
            font-weight: 400;
            line-height: 1;
            color: #3e3e3e;
            text-transform: none;
          "
        >
          Duración:
        </span>
        <span
          style="
            font-family: 'Rubik';
            font-size: 13px;
            font-weight: 500;
            line-height: 1;
            color: #000000;
            text-transform: none;
          "
        >
          {{ item?.experience?.duration || 'No definido' }}
        </span>
      </div>

      <div class="d-flex flex-column mb-4">
        <span
          style="
            font-family: 'Rubik';
            font-size: 13px;
            font-weight: 400;
            line-height: 1;
            color: #3e3e3e;
            text-transform: none;
          "
        >
          Guía:
        </span>
        <span
          style="
            font-family: 'Rubik';
            font-size: 13px;
            font-weight: 500;
            line-height: 1;
            color: #000000;
            text-transform: none;
          "
        >
          {{ item.experience?.language || 'No disponible' }}
        </span>
      </div>
    </div>

    <!-- Right Column -->
    <div class="col-6">
      <!-- Childrens -->
      <div class="d-flex align-items-center mb-4" style="gap: 2px;">
        <img width="20" height="20" src="../../../../../../assets/icons/search-result/hotel/NIÑO.svg"/>
        <span style="font-family: 'Rubik'; font-size: 13px; font-weight: 400; text-transform: none;">{{ item.childrens }} {{ item.childrens === 1 ? 'Niño' : 'Niños' }}</span>
      </div>

      <!-- Time -->
      <div class="d-flex flex-column mb-4">
        <span
          style="
            font-family: 'Rubik';
            font-size: 13px;
            font-weight: 400;
            line-height: 1;
            color: #3e3e3e;
            text-transform: none;
          "
        >
          Hora:
        </span>
        <span
          style="
            font-family: 'Rubik';
            font-size: 13px;
            font-weight: 500;
            line-height: 1;
            color: #000000;
            text-transform: none;
          "
        >
          {{ item?.experience?.sessions ? item?.experience?.sessions + ' hs.' : item?.selectHour ? item?.selectHour + ' hs.' : 'No definido' }}
        </span>
      </div>

      <!-- City Name -->
      <div class="d-flex flex-column mb-4">
        <span
          style="
            font-family: 'Rubik';
            font-size: 13px;
            font-weight: 400;
            line-height: 1;
            color: #3e3e3e;
            text-transform: none;
          "
        >
          Ciudad:
        </span>
        <span
          style="
            font-family: 'Rubik';
            font-size: 13px;
            font-weight: 500;
            line-height: 1;
            color: #000000;
            text-transform: none;
          "
        >
          {{ item.form.destination.city_province }}
        </span>
      </div>

      <!-- Pick Up -->
      <div class="d-flex flex-column mb-4">
        <span
          style="
            font-family: 'Rubik';
            font-size: 13px;
            font-weight: 400;
            line-height: 1;
            color: #3e3e3e;
            text-transform: none;
          "
        >
          Pick Up:
        </span>
        <span
          style="
            font-family: 'Rubik';
            font-size: 13px;
            font-weight: 500;
            line-height: 1;
            color: #000000;
            text-transform: none;
          "
        >
          {{ item.form.destination.city_province }}
        </span>
      </div>
    </div>
  </div>
</usb-base-item>
